import React from 'react';
import { List } from 'react-admin';
import Box from '@mui/material/Box';

import { useTitle } from '@src/hooks/useTitle';
import WithPricingGuard from './WithPricingGuard';
import ConditionDiscountsStatusBanner from './ConditionDiscountsStatusBanner';
import ConditionDiscountsToolbar from './ConditionDiscountsToolbar';
import ConditionDiscountsDataTable from './ConditionDiscountsDataTable';
import ConditionDiscountsActions from './ConditionDiscountsActions';
import ConditionDiscountsDocumentation from './ConditionDiscountsDocumentation';

const PRICING_TYPE = 'condition' as const;

const ConditionDiscountsList = () => {
  const { title } = useTitle('Condition Discount Rules');

  return (
  <WithPricingGuard>
    <List
      perPage={10}
      sort={{ field: 'position', order: 'ASC' }}
      title={title}
      actions={<ConditionDiscountsActions pricingType={PRICING_TYPE} />}
    >
      <ConditionDiscountsStatusBanner pricingType={PRICING_TYPE} />
      <ConditionDiscountsToolbar pricingType={PRICING_TYPE} />
      <ConditionDiscountsDataTable pricingType={PRICING_TYPE} />
    </List>
    <Box sx={{ px: 2, pb: 2 }}>
      <ConditionDiscountsDocumentation />
    </Box>
  </WithPricingGuard>
  );
};

export default ConditionDiscountsList;
